import { Checkbox, HStack, Text } from '@chakra-ui/react'
import { components, OptionProps } from 'react-select'

type Props = OptionProps<any, boolean, any> & {
	isFontPicker?: boolean
	showCheckbox?: boolean
}

export const Option = (props: Props) => {
	const onOptionClick = (e: React.MouseEvent<HTMLDivElement>) => {
		props.selectOption({ ...props.data })
		e.stopPropagation()
		e.preventDefault()
	}

	return (
		<components.Option {...props}>
			<HStack justifyContent="space-between" gap={4} onClick={onOptionClick}>
				<HStack gap={3}>
					{props.isMulti && props.showCheckbox && (
						<Checkbox isChecked={props.isSelected} />
					)}
					{props.data.prefix}
					<Text fontFamily={props.isFontPicker ? props.data.value : 'inherit'}>
						{props.children}
					</Text>
				</HStack>
				{props.data.suffix}
			</HStack>
		</components.Option>
	)
}
